import axios from "axios";
import { parseISO } from "date-fns";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AdvisorId, ClientId, Prefix, Suffix, } from "../../Types";
import ValidationError from "../../ZodError";
export const url = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/v1/clients`
        : `https://middleware.uat.farther.com/entity/v1/clients`;
};
const Response = z.object({
    client: z.object({
        clientId: ClientId,
        advisorId: AdvisorId,
        name: z.object({
            prefix: Prefix.nullable(),
            first: z.string(),
            middle: z.string().nullable(),
            last: z.string(),
            suffix: Suffix.nullable(),
        }),
        emailAddress: z.string(),
        phoneNumber: z.string().nullable(),
        registeredTime: z
            .string()
            .datetime()
            .transform((s) => parseISO(s)),
        lastLoginTime: z.null(),
    }),
});
export default async function postClient(request, config) {
    const { data } = await axios.post(url(), request, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "postClient returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postClient.js.map